// extracted by mini-css-extract-plugin
export var focusItem = "styles-module--focus-item--CIvJG";
export var focusItems = "styles-module--focus-items--ghgBi";
export var headerResearchFocus = "styles-module--header-research-focus--2Lhyv";